module.exports = __webpack_public_path__ + "static/media/ganesh.783e676f.png";